export default "__VITE_PUBLIC_ASSET__d1ce9110__"